export default {
  prjSkillFile: [],
  prjSkillData: [],
  srchParam: {},
  viewFileUpload: false,
};
